/**
 * Membership tier helpers, driven by the /v3/me fields:
 *   MembershipTier      e.g. "family_office" | "wealth_capital" | "mars" | "centurion" | "premium" | "" (free)
 *   MembershipExpiresAt ISO date string, or null for a lifetime grant
 */

export const FAMILY_OFFICE_TIER = "family_office";

/** True when the user holds a non-expired membership tier. */
export const isMembershipActive = (user) => {
  if (!user || !user.MembershipTier) return false;
  if (!user.MembershipExpiresAt) return true; // lifetime grant
  const expiresAt = new Date(user.MembershipExpiresAt).getTime();
  return Number.isNaN(expiresAt) || expiresAt > Date.now();
};

/** True when the user has no active membership tier. */
export const isFreeUser = (user) => !isMembershipActive(user);

/** True when the user holds a non-expired Family Office membership. */
export const isFamilyOffice = (user) => {
  if (!isMembershipActive(user)) return false;
  return String(user.MembershipTier).toLowerCase() === FAMILY_OFFICE_TIER;
};
